<div class="profile-container">
    <div class="">
        <div class="profile-content">
          <!-- <button class="add-ticket" data-toggle="modal" data-target="#exampleModal">Add Product</button> -->
  
            <div class="personal-details">
                <h4 class="personal-details-title">Product Master</h4>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Product ID</th>
                      <th scope="col">Product Name</th>
                      <th scope="col">Product Description</th>
                      <th scope="col">Product Group</th>
                      <th scope="col">Product Code</th>
                      <th scope="col">Product Template</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let x of product | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: page,
                      totalItems: count
                    };let i = index">
                      <th scope="col">{{x.productMasterId}}</th>
                      <th scope="col">{{x.name}}</th>
                      <th scope="col">{{x.description}}</th>
                      <th scope="col">{{x.group}}</th>
                      <th scope="col">{{x.code | number}}</th>
                      <th scope="col">{{x.version}}</th>
                    </tr>
                  </tbody>
              </table>
              <div class="pagination-block" *ngIf="product.length != 0">
                <pagination-controls
                  previousLabel="Prev"
                  nextLabel="Next"
                  (pageChange)="onTableDataChange($event)"
                >
                </pagination-controls>
              </div>
            </div>
  
        </div>
    </div>
</div>
  
  
<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add Product
          <span data-dismiss="modal">
            <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body">
  
        <div [formGroup]="form">
  
            <div class="form-group">
                <label>Product Name</label>
                <input formControlName="name" type="text" class="form-control">
            </div>
            <div class="form-group">
                <label>Product Description</label>
                <input formControlName="description" type="text" class="form-control">
            </div>
            <div class="form-group">
                <label>Product Group</label>
                <input formControlName="group" type="text" class="form-control">
            </div>
            <div class="form-group">
                <label>Product Code</label>
                <input formControlName="code" type="number" class="form-control">
            </div>
            <div class="form-group ">
              <label>Select UOMs</label>
              <ng-multiselect-dropdown
              [placeholder]="'select uoms'"
              [settings]="uomDropdownSettings"
              [data]="uomDropdownList"
              [(ngModel)]="uomSelectedList"
              class="form-control"
              style="padding: 0;border: none"
              [ngModelOptions]="{standalone: true}"
              (onSelect)="onItemSelect($event)"
              (onSelectAll)="onSelectAll($event)"
              >
              </ng-multiselect-dropdown>
            </div>
            <div class="form-group">
              <label>Select Default UOM</label>
              <select class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="isDefault">
                <option value="" disabled selected hidden>-- select default uom --</option>
                <option *ngFor="let uom of uomSelectedList" [value]="uom.uomMasterId">{{uom.uomName}}</option>
              </select>
            </div>
            <div class="form-group" *ngFor="let list of keyValueList">
              <label>{{list.key}}</label>
              <input type="text" class="form-control" *ngIf="list.possibleValue.length == 0" [ngModelOptions]="{standalone: true}" [(ngModel)]="list.value">
              <select class="form-control" *ngIf="list.possibleValue.length != 0" [ngModelOptions]="{standalone: true}" [(ngModel)]="list.value">
                <option *ngFor="let possibleValue of list.possibleValue" [value]="possibleValue">{{possibleValue}}</option>
              </select>
            </div>
            <div class="form-group">
                <label>Product Version</label>
                <select formControlName="version" class="form-control" name="" id="">
                  <option value="1">version 1</option>
                  <option value="2">version 2</option>
                </select>
            </div>
  
            <!-- <div class="form-group">
                <label>Active status</label>
                <input  type="checkbox" formControlName="isActive" class="form-control">
            </div> -->
  
        </div>
  
   
      <div class="modal-footer">
        <button type="button" id="closeModalButton"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" (click)="addProduct()" class="btn btn-primary">Add Product</button>
      </div>
    </div>
  </div>
  </div>
</div>